import React from 'react'

export function ProductPageMobile() {
  return (
    <div>ProductPageMobile</div>
  )
}

 